import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Route } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/route.interface';
import { StopMessagesForDayResponse, StopTimesWithRoute } from 'src/app/modules/route-planner/interfaces/route-planning/service/@schedule-service.interface';

@Component({
    selector: 'app-search-station-detailed-result-routes-calendar-list',
    templateUrl: './search-station-detailed-result-routes-calendar-list.component.html',
    styleUrls: ['./search-station-detailed-result-routes-calendar-list.component.scss'],
    standalone: false
})
export class SearchStationDetailedResultRoutesCalendarListComponent {

  @Input() stopTimes: StopTimesWithRoute[]
  @Input() lines: Route[]
  @Input() routeSpecialMessages: StopMessagesForDayResponse['routeSpecialMessages'] = {};
  @Input() isToday: boolean
  @Input() selectedDate: Date | null = null;
  @Input() selectedTime: string | null = null;
  @Input() stopCode: number;
  @Output() pickLineEvent = new EventEmitter<Route>();

  get filteredStopTimes(): StopTimesWithRoute[] {
    return this.stopTimes?.filter(stopTime => 
      this.lines?.some(line => line.routeId === stopTime.routeId)
    ) || [];
  }
}
